package com.macrofocus.eflux.ui

import com.macrofocus.eflux.lod.NodeLOD
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.ui.svg.SVGPathBuilder
import mui.material.styles.Theme
import mui.material.styles.useTheme
import org.mkui.geom.Arc2D
import org.mkui.geom.GeneralPath
import org.mkui.geom.PathIterator
import org.molap.dataframe.DataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import react.FC
import react.Props
import react.dom.html.ReactHTML.title
import react.dom.svg.ReactSVG.circle
import react.dom.svg.ReactSVG.path
import react.dom.svg.ReactSVG.svg
import web.svg.SVGGraphicsElement

enum class ChordTemplate {
    Circle,
    OriginalShape
}

external interface ChordProps : Props {
    var dataFrame: DataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?>?
    var dateTime: Long
    var originalShape: SVGGraphicsElement
}

val Chord = FC<ChordProps> { props ->
    val theme = useTheme<Theme>()
    val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light

    val dataFrame = props.dataFrame

    if(dataFrame != null) {
        val lod = NodeLOD(props.originalShape, dataFrame)
        val originalBBox = lod.originalBBox
        val centerX = lod.centerX
        val centerY = lod.centerY
        val screenInnerRadius = lod.screenInnerRadius
        val screenOuterRadius = lod.screenOuterRadius

        val template = lod.template

        svg {
            viewBox = "${originalBBox.x} ${originalBBox.y} ${originalBBox.width} ${originalBBox.height}"

            val model = lod.chordModel
            for (node in model.nodes) {
                val chord = model.getArc(node)

                if (chord != null) {
                    // Draw a dot to represent the center of a node
                    val p = lod.computeOuterPoint((chord.startAngle + (chord.extent / 2)))
                    circle {
                        cx = p.x
                        cy = p.y
                        r = 0.15
                        fill = if(lod.nodesWithExternalConnections.contains(node)) "rgba(255, 0, 0, 0.5)" else "rgba(0, 255, 0, 0.5)"
                    }

                    // Draw the sector
                    when(template) {
                        ChordTemplate.Circle -> {
                            val path = GeneralPath()
                            val outerArc: PathIterator = lod.sectorOfNode(template, centerX, centerY, screenOuterRadius, chord.startAngle, chord.extent)
                            val innerArc: Arc2D = Arc2D.Double.getArcByCenter(
                                centerX,
                                centerY,
                                screenInnerRadius,
                                90 - (chord.startAngle + chord.extent),
                                chord.extent,
                                Arc2D.OPEN
                            )
                            path.append(outerArc, false)
                            path.append(innerArc.getPathIterator(), true)
                            path.closePath()

                            val d = SVGPathBuilder(path.getPathIterator()).toString()

                            path {
                                this.d = d
                                fill = "rgba(0, 0, 127, 0.5)"
                                stroke = "rgba(0, 0, 255, 0.5)"
                                strokeWidth = 0.01
                                title {
                                    +node.id
                                }
                            }
                        }
                        else -> {}
                    }
                    }
            }

            for (from in model.nodes) {
                for (link in model.getLinks(from)) {
                    val to = model.getTo(link)

                    val shape = lod.getShape(from, to)
                    if (shape != null) {
                        val p = SVGPathBuilder(shape.getPathIterator()).toString()

                        path {
                            d = p
                            fill = if(lod.nodesWithExternalConnections.contains(link.from) || lod.nodesWithExternalConnections.contains(link.to)) "rgba(255, 0, 0, 0.5)" else "rgba(0, 255, 0, 0.5)"
                            stroke = "rgba(0, 0, 0, 0.5)"
                            strokeWidth = 0.01
                            title {
                                +link.id
                            }
                        }
                    }
                }
            }
        }
    }
}

